import { createFileRoute, Navigate, useParams } from '@tanstack/react-router'

export const Route = createFileRoute('/guest/logged_in/$pin/')({
  component: IndexComponent,
})

function IndexComponent() {
  const params = useParams({ from: '/guest/logged_in/$pin/' })
  // Redirect to invitation page by default
  return <Navigate to="/guest/logged_in/$pin/invitation" params={{ pin: params.pin }} />
}
